import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import InlineSVG from 'svg-inline-react';

import classes from './Invitation.scss';
import Logo from '../../../assets/logo_login.svg';
import { simplApi } from '../../../api/simplApi';
import { Link } from 'react-router';

class Invitation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: 'none',
      invitor: '',
      company: '',
      name: '',
      email: '',
      password: '',
      password_confirm: '',
      error: '',
    };
  }

  componentDidMount() {
    this.getInvitationData();
  }

  getInvitationData = () => {
    const url = `invitation/${this.props.params.token}`;

    simplApi(url)
      .then(data => data.json())
      .then(json => {
        if (typeof json.error !== 'undefined') {
          // error handling
        } else {
          this.setState({
            invitor: json.invitor,
            company: json.company,
            name: json.invited,
            email: json.email,
          });
        }
      });
  };

  checkLogin = () => {
    const url = `invitation/${this.props.params.token}`;
    const options = { method: 'post', body: this.state };

    simplApi(url, options)
      .then(data => data.json())
      .then(json => {
        if (typeof json.error !== 'undefined') {
          // error handling
          // // console.log(json.error);
          this.setState({ error: json.error });
        } else {
          // console.log(json);
          localStorage.setItem('token', json.token);
          window.location = `${window.location.origin}/dashboard`;
        }
      });
  };

  renderText = () => {
    if (this.state.answer === 'none') {
      return (
        <div>
          <p>Besitzen Sie bereits einen SiMPL Account?</p>

          <br />

          <RaisedButton
            label="Nein"
            onClick={() => this.setState({ answer: 'create' })}
            primary
            style={{ marginRight: 20 }}
          />

          <RaisedButton
            label="Ja"
            onClick={() => this.setState({ answer: 'login' })}
          />
        </div>
      );
    } else if (this.state.answer === 'login') {
      return (
        <div className="form">
          <p>
            Loggen Sie sich einfach ein, um Ihren bestehenden SiMPL Account mit
            dem Unternehmen {this.state.company} zu verknüpfen.
          </p>

          <p>
            Sollten Sie Ihr Passwort vergessen haben, können Sie
            <Link to="/login?forgot=true" target="_blank">
              hier
            </Link>
            ein neues anlegen.
          </p>

          <div className="row">
            <div className="col-xs-12">
              <label className="simpl-label">E-Mail Adresse</label>
            </div>
            <div className="col-xs-12">
              <input
                type="email"
                name="username"
                onChange={e => this.setState({ email: e.target.value })}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <label className="simpl-label">Passwort</label>
            </div>
            <div className="col-xs-12">
              <input
                type="password"
                name="password"
                onChange={e => this.setState({ password: e.target.value })}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <RaisedButton
                label="Login &amp; Verknüpfen"
                onClick={() => this.checkLogin()}
                primary
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="form">
        <p>
          Erstellen Sie einen kostenfreien SiMPL Account um dem Unternehmen{' '}
          {this.state.company} beizutreten.
        </p>

        <div className="row">
          <div className="col-xs-12">
            <label className="simpl-label">Name</label>
          </div>
          <div className="col-xs-12">
            <input
              type="name"
              name="name"
              value={this.state.name}
              onChange={e =>
                this.setState({
                  name: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <label className="simpl-label">E-Mail Adresse</label>
          </div>
          <div className="col-xs-12">
            <input
              type="email"
              name="username"
              value={this.state.email}
              onChange={e =>
                this.setState({
                  email: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <label className="simpl-label">Passwort</label>
          </div>
          <div className="col-xs-12">
            <input
              type="password"
              name="password"
              onChange={e =>
                this.setState({
                  password: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <label className="simpl-label">Passwort bestaetigen</label>
          </div>
          <div className="col-xs-12">
            <input
              type="password"
              name="password_confirm"
              onChange={e =>
                this.setState({
                  password_confirm: e.target.value,
                })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <RaisedButton
              label="Anmelden"
              onClick={() => this.checkLogin()}
              primary
            />
          </div>
        </div>
      </div>
    );
  };
  renderError = () => {
    if (this.state.error.length) {
      return <h4 className={classes.error}>{this.state.error}</h4>;
    }
    return null;
  };
  render() {
    return (
      <div className={classes.wrapper}>
        <div className={classes.invitation}>
          <div className={classes.logoWrapper}>
            <InlineSVG src={Logo} className={classes.logo} />
          </div>
          <h1>Willkommen bei SiMPL</h1>
          <h4>
            Sie wurden von {this.state.invitor} eingeladen, am SiMPL Unternehmen{' '}
            {this.state.company} mitzuwirken.
          </h4>

          {this.renderError()}

          {this.renderText()}
        </div>
      </div>
    );
  }
}
Invitation.propTypes = {
  params: PropTypes.object.isRequired,
};
export default Invitation;



// WEBPACK FOOTER //
// ./src/routes/Invitation/components/Invitation.js